// UI strings for the marketing layout + shared components (EN + PL; de/es/uk in
// i18n packs). Kept out of locales/*.json on purpose (home.* there belongs to the landing CMS).
// Pure data: also loaded by the build prerender.
export const EN = {
  skip: 'Skip to content',
  nav_label: 'Main',
  features: 'Features',
  pricing: 'Pricing',
  faq: 'FAQ',
  verify: 'Verify a document',
  developers: 'Developers & API',
  language: 'Language',
  sign_in: 'Sign in',
  book_demo: 'Book a demo',
  dashboard: 'Go to dashboard',
  menu: 'Menu',
  footer_blurb: 'E-signatures on your own domain, with your branding and your email sender. Built for offices, coworkings and accounting firms.',
  footer_product: 'Product',
  footer_company: 'Company',
  footer_legal: 'Legal',
  all_features: 'All features',
  contact: 'Contact',
  status: 'Status',
  privacy: 'Privacy policy',
  terms: 'Terms of service',
  dpa: 'Data processing agreement',
  subprocessors: 'Sub-processors',
  rodo: 'Request my data (GDPR)',
  faq_title: 'Frequently asked questions',
  cta_title: 'See it on your own documents',
  cta_lead: 'Book a short demo and we will set up a trial organization with your domain and branding.',
  not_found_title: 'Page not found',
  not_found_lead: 'The page you are looking for does not exist or has moved.',
  back_home: 'Back to home',
  home: 'Home',
  breadcrumb: 'Breadcrumb',
  feature_kicker: 'Feature',
  more_features: 'More features',
  see_all: 'See all features',
  see_pricing: 'See pricing',
  read_more: 'Read more',
  per_month: 'PLN / month',
  net_note: 'net + VAT',
  custom_price: 'Custom',
  custom_note: 'Priced to your volume',
  recommended: 'Recommended',
  choose_plan: 'Choose',
  contact_sales: 'Contact sales',
  compare_kicker: 'Side by side',
  compare_title: 'Compare plans',
  feature_col: 'Feature',
  included: 'Included',
  not_included: 'Not included',
  scroll_hint: 'Swipe sideways to compare all plans',
  dev_title: 'Start building',
  dev_lead: 'Full API reference, a five-minute quickstart and official SDKs for Python and TypeScript.',
  dev_reference: 'API reference',
  dev_quickstart: 'Quickstart',
  dev_sdks: 'SDKs',
  copy: 'Copy',
  copied: 'Copied',
  pricing_faq_title: 'Billing questions',
  not_found_try: 'Maybe you were looking for',
  lang_suggest: 'This page is also available in English.',
  lang_switch: 'Read in English',
  lang_dismiss: 'No thanks',
}
export type MkKey = keyof typeof EN

export const PL: Record<MkKey, string> = {
  skip: 'Przejdź do treści',
  nav_label: 'Główna nawigacja',
  features: 'Funkcje',
  pricing: 'Cennik',
  faq: 'FAQ',
  verify: 'Zweryfikuj dokument',
  developers: 'Dla programistów i API',
  language: 'Język',
  sign_in: 'Zaloguj się',
  book_demo: 'Umów demo',
  dashboard: 'Przejdź do panelu',
  menu: 'Menu',
  footer_blurb: 'Podpisy elektroniczne pod Twoją domeną, z Twoim brandingiem i nadawcą e-maili. Dla biur wirtualnych, coworkingów i biur rachunkowych.',
  footer_product: 'Produkt',
  footer_company: 'Firma',
  footer_legal: 'Dokumenty',
  all_features: 'Wszystkie funkcje',
  contact: 'Kontakt',
  status: 'Status usług',
  privacy: 'Polityka prywatności',
  terms: 'Regulamin',
  dpa: 'Umowa powierzenia',
  subprocessors: 'Podprocesorzy',
  rodo: 'Wniosek RODO',
  faq_title: 'Najczęstsze pytania',
  cta_title: 'Zobacz to na swoich dokumentach',
  cta_lead: 'Umów krótkie demo, a przygotujemy testową organizację z Twoją domeną i brandingiem.',
  not_found_title: 'Nie znaleziono strony',
  not_found_lead: 'Strona, której szukasz, nie istnieje albo została przeniesiona.',
  back_home: 'Wróć na stronę główną',
  home: 'Strona główna',
  breadcrumb: 'Ścieżka nawigacji',
  feature_kicker: 'Funkcja',
  more_features: 'Inne funkcje',
  see_all: 'Zobacz wszystkie funkcje',
  see_pricing: 'Zobacz cennik',
  read_more: 'Czytaj dalej',
  per_month: 'PLN / mies.',
  net_note: 'netto + VAT',
  custom_price: 'Indywidualnie',
  custom_note: 'Wycena pod Twój wolumen',
  recommended: 'Polecany',
  choose_plan: 'Wybierz',
  contact_sales: 'Napisz do sprzedaży',
  compare_kicker: 'Porównanie',
  compare_title: 'Porównaj plany',
  feature_col: 'Funkcja',
  included: 'W planie',
  not_included: 'Brak w planie',
  scroll_hint: 'Przesuń w bok, aby porównać wszystkie plany',
  dev_title: 'Zacznij integrację',
  dev_lead: 'Pełna dokumentacja API, pięciominutowy quickstart i oficjalne SDK dla Pythona i TypeScriptu.',
  dev_reference: 'Dokumentacja API',
  dev_quickstart: 'Szybki start',
  dev_sdks: 'SDK',
  copy: 'Kopiuj',
  copied: 'Skopiowano',
  pricing_faq_title: 'Pytania o rozliczenia',
  not_found_try: 'Może szukasz',
  lang_suggest: 'Ta strona jest dostępna także po polsku.',
  lang_switch: 'Czytaj po polsku',
  lang_dismiss: 'Nie, dziękuję',
}
